import {Component, input} from '@angular/core';


@Component({
    selector: '[lib-skeleton-table-body]',
    imports: [],
    templateUrl: './skeleton-table-body.component.html',
    styleUrl: './skeleton-table-body.component.scss'
})
export class SkeletonTableBodyComponent {
	skeletonRows = input<number[]>()
	skeletonCells = input<number[]>()

}
